{
  "version": 1,
  "asset_id": "24fa9437-280f-4b4a-b3d0-350bff2a8254",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/24fa9437-280f-4b4a-b3d0-350bff2a8254/crystal-river-blue-shingle-roof-destination-roofing-1320w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/24fa9437-280f-4b4a-b3d0-350bff2a8254/crystal-river-blue-shingle-roof-destination-roofing-1320w.webp",
  "original_filename": "crystal-river-blue-shingle-roof-destination-roofing-1320w.webp",
  "size": 106200,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:47Z"
}
